import React from 'react'
import * as translationService from './../services/translationService'
import { Markdown } from './../components'

export default function() {
  return <Markdown source={translationService.privacyConditionsText()} />
}



// WEBPACK FOOTER //
// ./src/views/PrivacyView.js